import { render } from "./SelecionarCor.vue?vue&type=template&id=2f193730&scoped=true&ts=true"
import script from "./SelecionarCor.vue?vue&type=script&lang=ts"
export * from "./SelecionarCor.vue?vue&type=script&lang=ts"

import "./SelecionarCor.vue?vue&type=style&index=0&id=2f193730&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f193730"]])

export default __exports__